// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2Yjsq","list":"styles_list__A_5Hb"};